import { Injectable, inject } from "@angular/core";
import { WizardAbstractService } from "./wizard-abstract.service";
import { WizardStep } from "@app/core/model/wizard-step";
import { WizardIdEnum } from "@app/core/model/enum/wizard-id.enum";
import { ContextService } from "@app/core/service/context.service";

@Injectable({
    providedIn: 'root'
})
export class DdmIndicativeWizardService extends WizardAbstractService {
    private readonly contextService = inject(ContextService);

    constructor() {
        super();
        this.initRoute = '/product/10';
        this.idWizard = WizardIdEnum.DDM_INDICATIVE;
        this.label = 'VITAFRAIS: Guide de la DDM indicative';
        this.description = 'Apprenez l\'utilité de la DDM indicative.';

        const stepDiscoverDdmIndicative = WizardStep.create('discover-ddm-indicative', this)
            .withTitle('Nouveau !')
            .withText(`<b>DDM indicative</b><br><br>
                Retouvez désormais la DDM indicative à réception pour mieux gérer vos commandes.<br><br>
                <b><ul><li>Ajustez vos quantités</li><li>Optimisez vos rotations</li><li>Limitez les invendus</li></ul></b>`)
            .attachTo('#ddm-indicative-line', 'right')
            .waitForElement(2000)
            .addNextButton()
            .build();

        const stepLearnAboutDdmIndicative = WizardStep.create('learn-about-ddm-indicative', this)
            .withTitle('A noter :')
            .withText(`Ces informations sont non contractuelles, nous essayons de vous fournir l'information la plus précise possible mais celle-ci peut être susceptible d'évoluer en fonction de nos stocks.`)
            .attachTo('#ddm-indicative-info', 'right')
            .waitForElement(2000)
            .addCompleteButton()
            .build();

        this.addStep(stepDiscoverDdmIndicative);
        this.addStep(stepLearnAboutDdmIndicative);
    }

    override isAvailable(): boolean {
        return this.contextService.isVitafrais();
    }
}